import JumpList,{SELECTORS as JUMP_LIST_SELECTORS} from '../../../Components/JumpList/JumpList';

import '../../../Components/JumpList/_index.scss';
$(JUMP_LIST_SELECTORS.root).each((i, jumpList) => {
    new JumpList(jumpList);
});